
const it = {
    menu: {
        home: 'Home',
        adminSection: 'Amministrazione',
        quoteManage: 'Gestisci Preventivi',
        appSection: 'Applicazione',
        settings: {
            settings: 'Impostazioni',
            userList: 'Lista Utenti',
            addUser: 'Aggiungi Utente',
            companyProfile: 'Profilo Azienda',
            mutateCompanyProfile: 'Modifica Profilo Azienda',
            companySettings: 'Dati Azienda',
            accountSettings: 'Profilo Utente',
            logout: 'Esci',
        },
        user: {
            userList: 'Lista Utenti',
            addUser: 'Aggiungi Utente',
            mutateUser: 'Modifica Utente',
            userListSubTitle: 'Elenco utenti',
        },
        company: {
            companyList: 'Elenco Aziende',
            addCompany: 'Aggiungi Azienda',
            mutateCompany: 'Modifica Azienda',
            companySettings: 'Dati Azienda',
            companySettingsSubTitle: 'Dati azienda',
        },
        manager: {
            manager: 'Gestione',
            companyList: 'Elenco Aziende',
            productModelList: 'Elenco Modelli',
            pantoneList: 'Pantoni e Colori',
            optionalList: 'Accessori Modelli',
            measureList: 'Misure',
            measureGroupList: 'Misure',
            accessoryList: 'Accessori di Posa',
            priceList: 'Listini Prezzi',
        },
        superAdmin: {
            superAdmin: 'Super Admin'
        },
        misc: 'Varie',
        version: 'Versione ',
        versionBE: 'Versione BE ',
        profile: 'Profilo',
        quote: {
            quote: 'Preventivi',
            newQuote: 'Nuovo Preventivo',
            quoteList: 'Lista Preventivi',
            registry: 'Clienti'
        },
        logout: 'Esci',
        faq: 'Domane (FAQ)',
        comingSoon: 'Coming soon',
        superAdminSubtitle: 'Gestione utenti e profili',
        superAdminSection: 'Super Admin',
    },
}
export default it